// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__X6_1J","amount":"Amount_amount__3kMgp","tip":"Amount_tip__mufW0","tipHeader":"Amount_tipHeader__2LoaE","tipsWrap":"Amount_tipsWrap__3f5wY"};